import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GetYourFreeQuote from "./sections/GetYourFreeQuote";
import CommonQuestions from "./sections/CommonQuestions";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <GetYourFreeQuote />
      <CommonQuestions />
      <SiteFooter />
    </div>;
}